<template>
  <footer>
    <div class="center-wrapper">
      <div class="cicc-logo">
        <a href="http://www.cicc.com" target="_blank">
          <img
            class="footer-logo"
            src="@/assets/img/brand-logo-mobile.png"
            alt="cicc logo"
          />
        </a>
      </div>
      <div class="instruction">
        <p>
          &copy; 2011-2019 China International Capital Corporation Limited.
          京ICP备05004342号-1
        </p>
      </div>
      <a id="back-to-top" href="javascript:" title="返回顶部"></a>
    </div>
  </footer>
</template>
<script>
import "../../config/rem";
export default {
  name: "DefaultFooter",
};
</script>
<style lang="scss" scoped>
.center-wrapper {
  display: flex;
  margin: 0 auto;
  padding-bottom: 67px;
}

.cicc-logo {
  margin: 45px 31px 0 24px;
  width: 200px;
  height: 56px;
}

.footer-logo {
  width: 100%;
  height: 100%;
}

.instruction {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 33px;
  margin-top: 40px;
}
</style>
